/**
 * Style Utils
 * this file contains any css styles utils
 *
 * Naming Convention: camelCase
 * i.e. getColor
 */

import createCache from '@emotion/cache';
import { EmotionCache } from '@emotion/react';

import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';

const cacheLtr = createCache({
  key: 'muiltr',
});

const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

export function getEmotionCache(dir: string): EmotionCache {
  return dir === 'rtl' ? cacheRtl : cacheLtr;
}

export function shouldForwardProp(propName: string): boolean {
  return propName !== 'theme' && !propName.startsWith('$');
}

export function getLazyItemHeight(isRoundTrip: boolean, isMobile = true): number {
  if (!isMobile) {
    return !isRoundTrip ? 184 : 266;
  }
  return !isRoundTrip ? 225 : 325;
}
